import { Box } from '@material-ui/core';
import React from 'react';
import { useStyles } from './styles';

function BackDropModal({ handleClose }) {
  const classes = useStyles();

  return <Box className={classes.backDrop} onClick={handleClose} />;
}

export default BackDropModal;
